module.exports = require("react-signature-canvas");